import { makeObservable, observable, runInAction } from 'mobx';

import { injectable } from '@servicetitan/react-ioc';

import { IAuthStore } from '../../auth';

interface AuthInfo {
    isAuthenticated: boolean;
    isAuthorized: boolean;
    canAccessWebhooks: boolean;
    sessionId: string | null;
    name: string | null;
}

@injectable()
export class TokenServerStore implements IAuthStore {
    @observable.ref private authInfo: AuthInfo | null = null;

    constructor() {
        makeObservable(this);
        fetch('/auth/info').then(async response => {
            let authInfo: AuthInfo = {
                isAuthenticated: false,
                isAuthorized: false,
                canAccessWebhooks: false,
                sessionId: null,
                name: null,
            };
            try {
                if (response.ok) {
                    authInfo = await response.json();
                }
            } catch {
                // In case of any error, treat the user as unauthenticated.
            }
            runInAction(() => {
                this.authInfo = authInfo;
            });
        });
    }

    get isAuthenticated(): boolean | null {
        return this.authInfo !== null ? this.authInfo.isAuthenticated : null;
    }

    get isAuthorized(): boolean {
        return this.authInfo!.isAuthorized;
    }

    get canAccessWebhooks(): boolean {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        return this.authInfo !== null && this.authInfo.canAccessWebhooks;
    }

    get accessToken(): string {
        return ''; // not needed for Token Server
    }

    get userName(): string {
        return this.authInfo!.name!;
    }

    // eslint-disable-next-line @typescript-eslint/require-await
    async signOut(): Promise<void> {
        window.location.assign(
            '/auth/sign-out?sid=' + encodeURIComponent(this.authInfo!.sessionId!),
        );
    }
}
